import { useNavigate } from "react-router";
import { Icon } from "../../../components";
import { SPOTLIGHT } from "../../../constants/routes";
import { useDisplaySizeVariant } from "../../../hooks/useDisplaySizeVariant";
import { SpotlightBannerProducts } from "./components/SpotlightBannerProducts";
import { SpotlightBannerSupplier } from "./components/SpotlightBannerSuppliers";
import { useGetSpotlightPageData } from "../Spotlight.shared";

type SpotlightBannerPropsType = {
  pageId: string; // e.g. "uk-lager-2025", "spring-sessions-2025"
};
export const SpotlightBanner = ({ pageId }: SpotlightBannerPropsType) => {
  const navigate = useNavigate();

  const { data: currentPage } = useGetSpotlightPageData(pageId);

  const navigateToSpotlight = () => {
    return navigate(`${SPOTLIGHT.href({ spotlightId: pageId })}?type=featured`);
  };

  const { isDisplaySizeSatisfied, target } = useDisplaySizeVariant();
  const is3xl = isDisplaySizeSatisfied("3xl");
  if (!is3xl) {
    return (
      <div className="@container px-4" ref={target}>
        <SpotlightBannerMobile currentPage={currentPage} />
      </div>
    );
  }
  return (
    <>
      <div className="@container px-4" ref={target}>
        <div className="flex w-full cursor-pointer flex-row overflow-hidden rounded-lg border border-zinc-300 bg-white">
          <div className={"h-[260px] w-[390px]"} onClick={navigateToSpotlight}>
            <img
              src={
                currentPage.spotlightBannerUrl ||
                currentPage.bannerLargeUrl ||
                ""
              }
              alt={currentPage.title}
              className="aspect-3/2 h-full w-full shrink-0 bg-zinc-100 object-contain"
            />
          </div>
          <div className="inline-flex flex-1 items-center justify-start gap-6 overflow-hidden py-5 pr-8 pl-6">
            <div className="inline-flex flex-col items-start justify-center overflow-hidden">
              <div className="inline-flex items-center justify-start gap-6">
                {currentPage.type === "productList" && (
                  <>
                    <SpotlightBannerProducts
                      productIds={currentPage.entityIds}
                      pageId={pageId}
                    />
                  </>
                )}
                {currentPage.type === "queryProductList" && (
                  <>
                    <SpotlightBannerProducts
                      query={currentPage.query}
                      search={currentPage.search}
                      pageId={pageId}
                    />
                  </>
                )}
                {currentPage.type === "supplierList" && (
                  <SpotlightBannerSupplier
                    supplierIds={currentPage.entityIds}
                    onClick={navigateToSpotlight}
                  />
                )}
              </div>
              <div
                className="flex flex-col items-start justify-start gap-1 self-stretch"
                onClick={navigateToSpotlight}
              >
                <p className="mt-3 line-clamp-2 justify-end self-stretch font-sans text-base leading-normal font-normal text-zinc-700">
                  {currentPage.description}
                </p>
              </div>
            </div>
            <Icon
              onClick={navigateToSpotlight}
              icon="CHEVRON_RIGHT"
              className="flex-none"
            />
          </div>
        </div>
      </div>
    </>
  );
};

const SpotlightBannerMobile = ({
  currentPage,
}: {
  currentPage: ReturnType<typeof useGetSpotlightPageData>["data"];
}) => {
  const navigate = useNavigate();
  return (
    <div
      className="flex w-full cursor-pointer flex-col overflow-hidden rounded-lg border border-zinc-300 bg-white"
      onClick={() => {
        navigate(SPOTLIGHT.href({ spotlightId: currentPage.pageId }));
      }}
    >
      <div className={"h-[160px] w-full"}>
        <img
          src={
            currentPage.spotlightBannerUrl || currentPage.bannerLargeUrl || ""
          }
          alt={currentPage.title}
          className="aspect-3/2 h-full w-full shrink-0 bg-zinc-100 object-cover"
        />
      </div>
      <div className="inline-flex flex-1 shrink-0 items-center justify-start gap-2.5 overflow-hidden px-4 pt-6 pb-4">
        <div className="flex flex-col items-start justify-start gap-1 self-stretch">
          <p className="line-clamp-3 justify-end self-stretch font-sans text-base leading-normal font-normal text-zinc-700">
            {currentPage.description}
          </p>
        </div>
        <Icon icon="CHEVRON_RIGHT" className="flex-none" />
      </div>
    </div>
  );
};
